export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.382 3.105a.75.75 0 00-.764 0L4.502 7.311a.75.75 0 000 1.291l7.116 4.205a.75.75 0 00.764 0l7.116-4.205a.75.75 0 000-1.291l-7.117-4.206zM12 11.291L6.357 7.956 12 4.622l5.642 3.334L12 11.291zm-7.763.49a.75.75 0 011.028-.265L12 15.496l6.735-3.98a.75.75 0 11.763 1.291l-7.117 4.206a.75.75 0 01-.763 0l-7.116-4.206a.75.75 0 01-.264-1.027zm0 3.881a.75.75 0 011.028-.264L12 19.378l6.735-3.98a.75.75 0 01.763 1.291l-7.117 4.206a.75.75 0 01-.763 0l-7.116-4.206a.75.75 0 01-.265-1.027z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};